/* Compare tray (snippets/compare-tray.liquid), on every page: any product card's Compare tick ([data-compare]) adds the robot,
   up to 3, kept for the visit (sessionStorage), and the tray opens the compare page with ?robots=handle,handle.
   Stays hidden on pages with no Compare ticks. Ticks added later (filtered or lazy-loaded cards) are picked up too. */
if (!customElements.get('compare-tray')) {
  const MAX = 3;
  const KEY = 'bb-compare';

  class CompareTray extends HTMLElement {
    connectedCallback() {
      document.addEventListener('change', (e) => {
        const box = e.target.closest && e.target.closest('[data-compare]');
        if (!box) return;
        if (box.checked && this.picks().length > MAX) box.checked = false;
        this.sync(box);
        this.render();
      });
      this.querySelector('[data-clear]').addEventListener('click', () => {
        this.boxes().forEach((b) => { b.checked = false; });
        this.render();
      });
      this.restore();
      new MutationObserver(() => this.restore()).observe(document.body, { childList: true, subtree: true });
    }

    boxes() { return [...document.querySelectorAll('[data-compare]')]; }

    // One tick per robot: the same robot can be on a page twice (e.g. a card in two rows)
    picks() {
      const seen = new Set();
      return this.boxes().filter((b) => b.checked && !seen.has(b.value) && seen.add(b.value));
    }

    sync(box) { this.boxes().forEach((b) => { if (b !== box && b.value === box.value) b.checked = box.checked; }); }

    restore() {
      let saved = [];
      try { saved = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) {}
      let changed = false;
      this.boxes().forEach((b) => {
        if (!b.dataset.trayReady) { b.dataset.trayReady = '1'; if (saved.includes(b.value) && !b.checked) { b.checked = true; changed = true; } }
      });
      if (changed || !this.dataset.ready) { this.dataset.ready = '1'; this.render(); }
    }

    render() {
      const picks = this.picks();
      try { sessionStorage.setItem(KEY, JSON.stringify(picks.map((p) => p.value))); } catch (e) {}
      this.hidden = picks.length === 0;
      if (!picks.length) return;
      const box = this.querySelector('[data-picks]');
      box.innerHTML = '';
      picks.forEach((p) => {
        const item = document.createElement('span');
        item.className = 'coll-tray__pick';
        if (p.dataset.img) { const img = document.createElement('img'); img.src = p.dataset.img; img.alt = ''; item.append(img); }
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', p.dataset.title);
        remove.addEventListener('click', () => { p.checked = false; this.sync(p); this.render(); });
        item.append(remove);
        box.append(item);
      });
      for (let i = picks.length; i < MAX; i += 1) {
        const slot = document.createElement('span');
        slot.className = 'coll-tray__slot';
        slot.setAttribute('aria-hidden', 'true');
        slot.textContent = '+';
        box.append(slot);
      }
      this.querySelector('[data-names]').textContent = picks.map((p) => p.dataset.title).join(' and ');
      const hint = this.querySelector('[data-hint]');
      hint.textContent = picks.length < MAX ? hint.dataset.more : hint.dataset.max;
      const go = this.querySelector('[data-go]');
      go.href = `${go.dataset.base}?robots=${picks.map((p) => encodeURIComponent(p.value)).join(',')}`;
      go.querySelector('[data-go-label]').textContent = go.dataset.label.replace('[n]', picks.length);
    }
  }
  customElements.define('compare-tray', CompareTray);
}
